import React, { FC } from 'react';
import ErrorBoundaryLoggingToSentry from '../../../../../shared/components/util/ErrorBoundaryLoggingToSentry';
import { CardContentErrorFallback } from './CardContentErrorFallback';

export const CardContentErrorBoundary: FC = ({ children }) => (
  <ErrorBoundaryLoggingToSentry FallbackComponent={CardContentErrorFallback}>
    {children}
  </ErrorBoundaryLoggingToSentry>
);
